<template>
  <InputText
    v-model="inputValue"
    data-testid="search-product"
    leading-icon="ic_search"
    trailing-icon="ic_cancel"
    placeholder="Buscar produto"
    value=""
    :icon-has-hover="true"
    v-on="$listeners"
    @icon-click="clearInput()"
  />
</template>

<script lang="ts">
import { Vue, Component, Emit } from 'vue-property-decorator';
import { InputText } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    InputText
  }
})
export default class InstrumentsSearch extends Vue {
  public inputValue = '';

  @Emit('clear-search-input')
  clearInput() {
    this.inputValue = '';
  }
}
</script>
